// import React, { useState, useEffect } from 'react';
// import moment from 'moment';
// import { BarChart,Bar,Tooltip,CartesianGrid, XAxis, YAxis, ResponsiveContainer } from 'recharts';
// import Title from './Title';
// import { obtenerPresupuestosGrafico } from '../../actions/PresupuestosAction';
// // EDUARDO CANDIA

// export default function GraficoPresupuestosVendedores() {
//   const [data,setData]=useState([]);
 
//   const mes =moment().format('M');

//   useEffect(() => {
//     obtenerPresupuestosGrafico(mes).then(response=>{
//       if (response.status === 200){
//        const Data = response.data;
//        setData(Data);
//       }
//         });
//   }, [mes])

//   return (
//     <React.Fragment>
//       <Title>Presupuestos Ganados este Mes</Title>
//         <ResponsiveContainer  width={1000} heigth={240}  >
//           <BarChart  margin={{left:45}} width={1000} heigth={240} data={data}>
//             <XAxis height={277} dataKey='usuarioasignado' interval={0} angle = { -90 } textAnchor="end" stroke='#1976d2'/>
//             <YAxis  tickFormatter={tick => {
//               return tick.toLocaleString('es-MX');}}/>
//             <Tooltip formatter={(totalmes) =>new Intl.NumberFormat('es').format(totalmes)} 
//             labelFormatter ={(usuarioasignado)=> "USUARIO: "+(usuarioasignado)}
//             />
//             <CartesianGrid stroke="#ccc" strokeDasharray="5 5"/>
//             <Bar dataKey='totalmes' name="Total"  fill='#1976d2' barSize={30}/>
//           </BarChart>      
//           </ResponsiveContainer>
//     </React.Fragment>
//   );
// }

// #####################################################################
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import {
  BarChart,
  Bar,
  Tooltip,
  CartesianGrid,
  XAxis,
  YAxis,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend
} from 'recharts';
import { 
  Box, 
  Typography, 
  ToggleButtonGroup, 
  ToggleButton, 
  useMediaQuery, 
  useTheme,
  Chip,
  alpha
} from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { obtenerPresupuestosGrafico } from '../../actions/PresupuestosAction';

const COLORS = [
  '#1976d2', '#2196f3', '#03a9f4', '#00bcd4', 
  '#009688', '#4caf50', '#8bc34a', '#cddc39',
  '#ffeb3b', '#ffc107', '#ff9800', '#ff5722'
];

export default function GraficoPresupuestosVendedores() {
  const [data, setData] = useState([]);
  const [chartType, setChartType] = useState('bar');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  const mes = moment().format('M');
  const nombreMes = moment().format('MMMM YYYY');

  useEffect(() => {
    obtenerPresupuestosGrafico(mes).then(response => {
      if (response.status === 200) {
        const Data = response.data;
        setData(Data);
      } else {
        setData([]);
      }
    }).catch(error => {
      console.error("Error al obtener datos del gráfico:", error);
      setData([]);
    });
  }, [mes]);

  const handleChartTypeChange = (event, newType) => {
    if (newType !== null) {
      setChartType(newType);
    }
  };

  // Calcular totales
  const totalGeneral = data.reduce((sum, item) => sum + (item.totalmes || 0), 0);
  const cantidadVendedores = data.length;

  // Configuración responsive
  const chartHeight = isSmall ? 350 : isMobile ? 450 : 500;
  const outerRadius = isSmall ? 70 : isMobile ? 100 : 130;

  // Tooltip personalizado
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <Box
          sx={{
            backgroundColor: 'white',
            p: 2,
            borderRadius: 2,
            boxShadow: 3,
            border: '1px solid',
            borderColor: 'divider'
          }}
        >
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: 'primary.main' }}>
            {payload[0].payload.usuarioasignado}
          </Typography>
          <Typography variant="body2" sx={{ color: 'success.main', fontWeight: 600 }}>
            Total: ₲ {new Intl.NumberFormat('es').format(payload[0].value)}
          </Typography>
          {chartType === 'pie' && (
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {((payload[0].value / totalGeneral) * 100).toFixed(1)}% del total
            </Typography>
          )}
        </Box>
      );
    }
    return null;
  };

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      {/* Header */}
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between', 
        alignItems: { xs: 'flex-start', sm: 'center' },
        mb: 3,
        gap: 2
      }}>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
            <Box sx={{
              width: 40,
              height: 40,
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
              boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
            }}>
              <TrendingUpIcon sx={{ color: 'white', fontSize: 24 }} />
            </Box>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 700,
                fontSize: { xs: '1.1rem', sm: '1.3rem' }
              }}
            >
              Presupuestos Ganados
            </Typography>
          </Box>
          <Typography variant="caption" sx={{ color: 'text.secondary', ml: 6.5 }}>
            {nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1)}
          </Typography>
        </Box>
        
        <ToggleButtonGroup
          value={chartType}
          exclusive
          onChange={handleChartTypeChange}
          size="small"
          sx={{
            backgroundColor: 'background.paper',
            '& .MuiToggleButton-root': {
              border: '2px solid',
              borderColor: 'divider',
              '&.Mui-selected': {
                backgroundColor: 'primary.main',
                color: 'white',
                borderColor: 'primary.main',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                }
              }
            }
          }}
        >
          <ToggleButton value="bar" sx={{ px: 2 }}>
            <BarChartIcon sx={{ mr: 0.5 }} fontSize="small" />
            {!isSmall && 'Barras'}
          </ToggleButton>
          <ToggleButton value="pie" sx={{ px: 2 }}>
            <DonutLargeIcon sx={{ mr: 0.5 }} fontSize="small" />
            {!isSmall && 'Torta'}
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {/* Stats Cards */}
      <Box sx={{ 
        display: 'flex', 
        gap: 2, 
        mb: 3,
        flexWrap: 'wrap'
      }}>
        <Chip
          icon={<TrendingUpIcon />}
          label={`Total: ₲ ${new Intl.NumberFormat('es').format(totalGeneral)}`}
          sx={{
            backgroundColor: alpha(theme.palette.success.main, 0.1),
            color: 'success.main',
            fontWeight: 700,
            fontSize: '0.9rem',
            height: 36,
            px: 1
          }}
        />
        <Chip
          label={`${cantidadVendedores} Vendedor${cantidadVendedores !== 1 ? 'es' : ''}`}
          sx={{
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            color: 'primary.main',
            fontWeight: 600,
            fontSize: '0.85rem',
            height: 36
          }}
        />
      </Box>

      {/* Chart */}
      <Box sx={{ 
        backgroundColor: alpha(theme.palette.primary.main, 0.02),
        borderRadius: 2,
        p: { xs: 1, sm: 2 },
        border: '1px solid',
        borderColor: 'divider'
      }}>
        <ResponsiveContainer width="100%" height={chartHeight}>
          {chartType === 'bar' ? (
            <BarChart 
              margin={{ 
                left: isSmall ? 5 : 15, 
                right: isSmall ? 5 : 15, 
                top: 20, 
                bottom: isSmall ? 120 : isMobile ? 150 : 100
              }} 
              data={data}
            >
              <defs>
                <linearGradient id="colorBar" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#1976d2" stopOpacity={1}/>
                  <stop offset="100%" stopColor="#42a5f5" stopOpacity={0.8}/>
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke={alpha(theme.palette.divider, 0.3)} />
              <XAxis
                height={isSmall ? 120 : isMobile ? 150 : 100}
                dataKey='usuarioasignado'
                interval={0}
                angle={-45}
                textAnchor="end"
                stroke={theme.palette.text.secondary}
                style={{ 
                  fontSize: isSmall ? '9px' : isMobile ? '10px' : '12px',
                  fontWeight: 600
                }}
                tick={{ fill: theme.palette.text.primary }}
              />
              <YAxis 
                tickFormatter={tick => `₲${(tick / 1000).toFixed(0)}K`}
                stroke={theme.palette.text.secondary}
                style={{ fontSize: isSmall ? '9px' : '11px' }}
                tick={{ fill: theme.palette.text.primary }}
              />
              <Tooltip content={<CustomTooltip />} cursor={{ fill: alpha(theme.palette.primary.main, 0.1) }} />
              <Bar 
                dataKey='totalmes' 
                fill="url(#colorBar)"
                barSize={isSmall ? 15 : isMobile ? 25 : 35}
                radius={[8, 8, 0, 0]}
              />
            </BarChart>
          ) : (
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                labelLine={!isSmall}
                label={isSmall ? false : ({ usuarioasignado, percent }) =>
                  `${usuarioasignado} (${(percent * 100).toFixed(1)}%)`
                }
                outerRadius={outerRadius}
                innerRadius={outerRadius * 0.6}
                dataKey="totalmes"
                nameKey="usuarioasignado"
                paddingAngle={2}
              >
                {data.map((entry, index) => (
                  <Cell 
                    key={`cell-${index}`} 
                    fill={COLORS[index % COLORS.length]}
                    style={{
                      filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.2))'
                    }}
                  />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
              <Legend 
                wrapperStyle={{ 
                  fontSize: isSmall ? '10px' : '12px',
                  paddingTop: '20px'
                }}
                iconSize={isSmall ? 10 : 12}
                iconType="circle"
              />
            </PieChart>
          )}
        </ResponsiveContainer>
      </Box>

      {data.length === 0 && (
        <Box sx={{ 
          textAlign: 'center', 
          py: 4,
          color: 'text.secondary'
        }}>
          <Typography variant="body2">
            No hay datos disponibles para este mes
          </Typography>
        </Box>
      )}
    </Box>
  );
}